import React, { Component } from 'react';
import MiCompAPI from "./../../util/api";
import InvoiceAdjustmentFrom  from "../elements/InvoiceAdjustment";
import ManageInvoiceForm from "../elements/ManageInvoiceForm";
import moment from "moment";
import {
  Row,
  Col,
  Layout,
  Modal,
  message,
} from "antd";
import TableWrapper from "../elements/TableWrapper";
const { Content } = Layout;
class InvoiceAdjustment extends Component {
  recon_trans = [
    {
      title: 'Check No',
      dataIndex: 'chq_no',
      key: '1',
      sorter: (a, b) => a.chq_no.localeCompare(b.chq_no),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Check Date',
      dataIndex: 'chq_date',
      key: '2',
      render: (text, record) =>
      record["chq_date"] !== null && record["chq_date"] !== ""
          ? moment(record["chq_date"]).format("MM/DD/YYYY")
          : "",
          sorter: (a, b) => new Date(a.chq_date) - new Date(b.chq_date),
          sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Check Amount',
      dataIndex: 'chq_Amt',
      key: '3',
      render: (text) => <> ${text} </>
    },
    {
      title: 'Payment Status',
      dataIndex: 'paid_flag',
      key: '4',
      sorter: (a, b) => a.paid_flag.localeCompare(b.paid_flag),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Reversal Reason',
      dataIndex: 'reversal_reason',
      key: '5',
      sorter: (a, b) => a.reversal_reason.localeCompare(b.reversal_reason),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Pay Advance',
      dataIndex: 'chq_pay_adv',
      key: '6',
      sorter: (a, b) => a.chq_pay_adv.localeCompare(b.chq_pay_adv),
      sortDirections: ["descend", "ascend"]
    }]
  adj_trans = [
    {
      title: 'Description Type',
      dataIndex: 'trans_type_desc',
      key: '1',
      sorter: (a, b) => a.trans_type_desc.localeCompare(b.trans_type_desc),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Transaction Note',
      dataIndex: 'trans_desc',
      key: '2',
      sorter: (a, b) => a.trans_desc.localeCompare(b.trans_desc),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Transaction Date',
      dataIndex: 'transaction_date',
      key: '3',
      render: (text, record) =>
      record["transaction_date"] !== null && record["transaction_date"] !== ""
          ? moment(record["transaction_date"]).format("MM/DD/YYYY")
          : "",
          sorter: (a, b) => new Date(a.transaction_date) - new Date(b.transaction_date),
          sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Transaction Amount',
      dataIndex: 'trans_amt',
      key: '4',
      render: (text) => <> ${text} </>
    },
    {
      title: 'Adjustment Invoice No',
      dataIndex: 'adj_inv_no',
      key: '5',
      sorter: (a, b) =>{
        a = a.adj_inv_no || '';
        b = b.adj_inv_no || '';
        return a.localeCompare(b);
      },
      sortDirections: ["descend", "ascend"]
    }]
  payhistory = [
    {
      title: 'Invoice No',
      dataIndex: 'inv_no',
      key: '1',
      sorter: (a, b) => a.inv_no.localeCompare(b.inv_no),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Entity Name',
      dataIndex: 'entity_name',
      key: '2',
      sorter: (a, b) => a.entity_name.localeCompare(b.entity_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Entity Type',
      dataIndex: 'entity_type',
      key: '3',
      sorter: (a, b) => a.entity_type.localeCompare(b.entity_type),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Invoice Amount',
      dataIndex: 'net_amt',
      key: '4',
      render: (text) => <> ${text} </>
    },
    {
      title: 'Adjustment Amount',
      dataIndex: 'adj_amt',
      key: '5',
      render: (text) => <> ${text} </>
    },
    {
      title: 'Adjusted Invoice No',
      dataIndex: 'adj_inv_no',
      key: '6',
      sorter: (a, b) => a.adj_inv_no.localeCompare(b.adj_inv_no),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Adjustment',
      dataIndex: '',
      key: '7',
      render: (record) => <> <i className="fa fa-pencil-square-o" style={{ color: 'var(--main-bg-color)' }} onClick={() => { this.UserDefaultHandler(record) }} /> </>
    }
  ]
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      invoice: null,
      record: [],
      carriers: [], months: [], years: [],
      inv_clients:[],
      lob: [],
      is_adj_show: false,
      trans_type_desc: []
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentWillMount = () => {
    this.getClientMasters();
  }
  UserDefaultHandler = (record) => {
    this.api.invoke(
      "Get_Client_Plan_Trans/"+record.inv_no,
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            inv_clients: data.data,
          });
        }
      }
    );
    this.setState({
      record,
      is_adj_show: !this.state.is_adj_show
    })
  }
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            carriers: data.carriers,
            months: data.months,
            years: data.years,
            lob: data.lobs,
            isloding: false,
            trans_type_desc: data.trans_type_desc
          });
        }
      },
      ["CARRIER", "MTH", "YR", "LOB", "TRANS_TYPE_DESC"]
    );
  }
  addDocumentSubmitHandler = (data) => {
    const { keys, Trans_amt, Trans_desc, Trans_type_desc ,client_id,plan_id} = data;
    var input = [];
    keys.map((z, i) => {
      input.push({
        inv_no: this.state.record.inv_no,
        masterObj: this.state.trans_type_desc.filter(x => x.id === Trans_type_desc[i])[0],
        Trans_desc: Trans_desc[i],
        Trans_amt: Trans_amt[i],
        plan_id:plan_id[i],
        client_id:client_id[i]
      });
      return null;
    })
    this.api.invoke(
      "Inv_Adj_Trans",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ is_adj_show: false });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        } else {
          message.destroy();
          message.error("Add document failed. Contact Support", 3);
        }
      },
      input
    );
  }
  SubmitHandler = (data) => {
    data = {
      IYear: data.IYear,
      IMonth: data.IMonth,
      ILob: data.ILob,
      IClient: data.IClient
    }
    this.setState({ isloding: true, invoice: [] });
    this.api.invoke(
      "GetInvoiceBymnthandyr",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              invoice: data.data,
              isloding: false
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  }
  render() {
    return (
      <Content>
         {this.state.is_adj_show ? (
          <Modal
            visible={this.state.is_adj_show}>
              <InvoiceAdjustmentFrom
              closeDrawerHandler={this.UserDefaultHandler}
              submitHandler={this.addDocumentSubmitHandler}
              trans_type_desc={this.state.trans_type_desc}
              inv_clients={this.state.inv_clients}
              width="800px"
              title="Invoice Adjustment"
            />  </Modal>
        ) : ""}
        <div className="mi_main_div">
          <Row style={{ marginBottom: '20px' }}>
            <Col span={12}>
              <p className="mi_table_title">Invoice Adjustment</p>
            </Col>
          </Row>
          <Row>
            <ManageInvoiceForm type="payment" submitHandler={this.SubmitHandler}></ManageInvoiceForm>
            {this.state.invoice ? <TableWrapper rowKey="id" columns={this.payhistory} data={this.state.isloding ? null : this.state.invoice}
              expandedRowRender={(record) => (
                <>
                  <TableWrapper rowKey="1" data={record.inv_Adj_Trans_Models} title="Invoice Adjustment" columns={this.adj_trans}  ></TableWrapper>
                </>
              )}
              loading={this.state.isloding} title="Invoice Summary" /> : ""}
          </Row>
        </div>
      </Content>)
  }
}
export default InvoiceAdjustment;